// extracted by mini-css-extract-plugin
module.exports = {"tagsInput":"_1wYJjC","form-textarea":"_3KLuTZ","form-select":"_1SNG9h","form-multiselect":"_1zBWpa","form":"_1Y2ZVf"};